import PollingContainer from './PollingContainer';

export default PollingContainer;